module.exports = __webpack_public_path__ + "img/home.c9fcad25.png";